import { guideIconHtml } from "@scalar-org/guide-icons";
import { html } from "../../helpers/html-template.js";
import { EditorClasses } from "../../styles.js";
const guideCardHtml = async (props) => {
  const titleHtml = props.title ? html`<p class="card-title">${props.title}</p>` : "";
  const cardIconClasses = [EditorClasses.Icon];
  const iconContentHtml = props.icon && props.title ? `${await guideIconHtml({ src: props.icon, classes: cardIconClasses })} ${titleHtml}` : props.icon ? await guideIconHtml({ src: props.icon, classes: cardIconClasses }) : props.title ? titleHtml : "";
  const leftIconHtml = await guideIconHtml({
    src: props.leftIcon,
    classes: cardIconClasses
  });
  const [openTag, closeTag] = props.href ? [
    [
      `<a href="${props.href}" class="card ${EditorClasses.Card}"`,
      props.target ? ` target="${props.target}"` : "",
      props.target === "_blank" ? ' rel="noopener noreferrer"' : "",
      ">"
    ].join(""),
    "</a>"
  ] : [`<div class="card ${EditorClasses.Card}">`, "</div>"];
  const cardContent = html`
    <div class="card-content">
      <div data-scalar-name="card-icon" class="card-content__icon">
        ${iconContentHtml}
      </div>
      <div class="card-content__text">
        <ssg-children></ssg-children>
      </div>
    </div>
  `;
  return html`
    ${openTag}
      ${leftIconHtml}
      ${cardContent}
    ${closeTag}
  `;
};
export {
  guideCardHtml
};
//# sourceMappingURL=component.js.map
